import { IMultiplyResultData } from './../../models/action/activityMultiply';
import { Log } from 'ng2-logger';
import Types, { GlobalState } from '../../models/action/core.d';
import { ISetActivityCopyList, ISetActivityMultiplyData } from '../../models/action/activityMultiply';
import * as Actions from '../constants/activityCopy';
import * as ActionsMultiply from '../constants/activityMultiply';
import storage from 'redux-persist/lib/storage';
import { ICourseContentMenuSetAction, ICourseContentsWeekActivitiesSetAction } from '../../models/action/coursePage';
import * as ActionsCoursePage from '../constants/coursePage';

const _logger = Log.create('Activity-Multiply Reducer');
const activityMultiplyReducer = (state = GlobalState().activityMultiply, action: Types.IAction) => {
    if (!state) {
        return state;
    }

    const newState: any = { ...state };

    if (action.type === ActionsMultiply.actions.SET_ACTIVITY_MULTIPLY_LIST) {
        const activityMultiplyAction = action as ISetActivityCopyList;
        newState.courseActivityList = activityMultiplyAction.courseActivityList;
    } 
    else if (action.type === ActionsMultiply.actions.SET_ACTIVITY_MULTIPLY_DATA) {
        const activityMultiplyAction = action as ISetActivityMultiplyData;
        newState.activityMultiplyDataList = activityMultiplyAction.activityMultiplyDataList;
    } 
    else if (action.type === ActionsCoursePage.actions.SET_COURSE_PAGE_COURSECONTENTS_WEEKS_ACTIVITIES) {
        const activityMultiplyAction = action as ICourseContentsWeekActivitiesSetAction;
        newState.courseContentWeekActivities = activityMultiplyAction.courseContentWeekActivities;
    } 
    else if (action.type === ActionsMultiply.actions.SET_START_ACTIVITY_MULTIPLY) {
        const activityMultiplyAction = action as IMultiplyResultData;
        newState.multiplyResultData = activityMultiplyAction.multiplyResultData;
    } 

    const persistCourseConfig = {
        key: 'activity-Multiply',
        storage,
    };

    return Object.assign({}, state, newState);
};

export default activityMultiplyReducer;
